import Vue from "vue";
import Vuex from "vuex";

// Store Modules
import account from "./modules/account";
import authentication from "./modules/authentication"
import teams from "./modules/teams"
import editor from "./modules/editor"
import search from "./modules/search"

Vue.use(Vuex);

export function createStore() {
    return new Vuex.Store({
        modules: {
            account,
            authentication,
            teams,
            editor,
            search
        },
        state() {
            return {};
        },
        getters: {},
        mutations: {},
        actions: {}
    });
}
